const Footer = function(){  
    //amazing component, really proud of this one, just gorgeous.  
    return(
        <footer>
            <p>Rob Klassen - Juno College of Technology, Cohort 36, Project 3 - <a href="https://robklassen.com/">RobKlassen.com</a></p>
        </footer>
    )
}

export default Footer